import { useEffect, useState } from 'react';

// Helper function để lấy width, có kiểm tra window tồn tại (cho SSR)
function getWindowWidth() {
  // Kiểm tra xem 'window' có được định nghĩa không (hữu ích cho Server-Side Rendering)
  const hasWindow = typeof window !== 'undefined';
  return hasWindow ? window.innerWidth : 0; // Trả về 0 nếu window không tồn tại
}

export default function useWindowWidth() {
  // State để lưu trữ width
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  useEffect(() => {
    // Chỉ chạy effect ở phía client
    if (typeof window === 'undefined') {
      return;
    }

    // Hàm xử lý resize
    function handleResize() {
      setWindowWidth(getWindowWidth());
    }

    // Thêm listener
    window.addEventListener('resize', handleResize);

    // Cleanup listener khi unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Chạy 1 lần khi mount

  // Trả về giá trị width
  return windowWidth;
}